import React from "react";
import PropTypes from "prop-types";
// Material imports
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
const useStyles = makeStyles({
  bottomMessage: {
    marginBottom: 16,
    paddingTop: 3,
    paddingBottom: 16,
    paddingLeft: 10
  }
});
const UserIdVerificationResult = ({
  t,
  profileFields
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const {
    verified,
    isIDServiceDown,
    failedToMatch,
    outOfTries
  } = profileFields;
  const renderError = error => {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "error"
    }, t(error)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, outOfTries && renderError("Sorry, your ID couldn't be verified."), failedToMatch && renderError("Your ID couldn't be verified. Please ensure that all details are correct and try again."), verified && /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(DoneIcon, {
    style: {
      color: theme.palette.success.main
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.bottomMessage,
    style: {
      color: theme.palette.success.main
    }
  }, t("Your ID has been successfully verified")))), isIDServiceDown && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    wrap: "nowrap",
    direction: "row",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      display: "flex",
      marginRight: 8
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    style: {
      color: theme.palette.error.main
    }
  })), renderError("We are sorry, our identity verification service is currently experiencing some technical issues. Please contact Limitless support if the issue persists.")));
};
export default UserIdVerificationResult;
UserIdVerificationResult.propTypes = {
  t: PropTypes.func.isRequired,
  profileFields: PropTypes.object.isRequired
};